
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import HomePage from 'pages/HomePage';
import TestimonialsPage from 'pages/TestimonialsPage';

const App = () => {

	return (
		<Router>
			<Routes>
				<Route path='/' element={<HomePage />} />
				<Route path='/testimonials' element={<TestimonialsPage />} />
			</Routes>
		</Router>
	);
};

export default App;




// import React from 'react';
// import { Shield, Sparkles, Send } from 'lucide-react';
// import './App.css';

// function App() {
//   return (
//     <div className="container">
//       <header className="header">
//         <h1>Client Project</h1>
//         <p>Simple, elegant, and fast static page.</p>
//       </header>

//       <main className="features">
//         <div className="card">
//           <Sparkles className="icon" />
//           <h3>Modern Design</h3>
//           <p>Clean layout tailored exactly to your client's brand.</p>
//         </div>

//         <div className="card">
//           <Shield className="icon" />
//           <h3>Secure &amp; Fast</h3>
//           <p>Built as a static site for maximum performance and security.</p>
//         </div>
//       </main>

//       <footer className="footer">
//         <button className="cta-button">
//           Get in Touch <Send size={16} style={{ marginLeft: '8px' }} />
//         </button>
//       </footer>
//     </div>
//   );
// }

// export default App;